import { useSellerPendingOfferCount } from './queries/sellerQueries';

export const usePendingOfferCount = (enabled = true) => {
  const { data: pendingCount = 0, refetch, isFetching } = useSellerPendingOfferCount(enabled);
  return { pendingCount, refreshPendingOffers: refetch, isFetching };
};

export default usePendingOfferCount;
